import type { DatadogInitConfig } from "@wayflyer/blackbox-fe";
import type { RumInitConfiguration } from "@datadog/browser-rum";

import { createRumBeforeSend } from "./rum-before-send";

type RumConfig = DatadogInitConfig & Partial<Pick<RumInitConfiguration, "beforeSend">>;
type RumEnv = "local" | "prod";

// Preview environments and E2E serve a `--mode test` build, which Vite still flags as PROD.
export const getRumEnv = (mode: string, origin: string): RumEnv =>
  mode === "production" && !origin.includes("dev") ? "prod" : "local";

export const baseConfig: Record<RumEnv, RumConfig> = {
  local: {
    applicationId: "c7065ccc-4ada-4f13-8bf0-102a9ec71489",
    clientToken: "pub30db66489f71e1af87499f5108ce00fc",
    service: "wayflyer-customer-web-(local)",
    env: "local",
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackFrustrations: false,
    traceSampleRate: 0,
    allowedTracingUrls: ["https://app.wayflyerdev.com"],
  },
  prod: {
    applicationId: "c2f5ed75-ca0f-4194-884f-2cb59bb039ee",
    clientToken: "pubd4045714a73d50e4cc7bbecfc75e8e1a",
    env: "prod",
    service: "wayflyer-customer-web",
    enableExperimentalFeatures: ["clickmap"],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    traceSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackFrustrations: true,
    trackSessionAcrossSubdomains: true,
    beforeSend: createRumBeforeSend(),
    allowedTracingUrls: [
      "https://app.wayflyer.com",
      "https://app.wayflyer.team",
      "https://wayflyer.com",
      "https://www.wayflyer.com",
    ],
  },
};
